import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";
import axios from "axios";
import Swal from "sweetalert2";

export default function DataTable_Component({
  columns,
  viewConsolidatedhistory,
}) {
  const [apidata, setApidata] = useState([]);
  const [dataFilter, setDataFilter] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  const fetchConsolidatedData = async (yearParam, monthParam) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      let url = `${process.env.REACT_APP_BASE_URL}/api/v4/consolidated-expenses`;

      // ✅ If year and month are provided, add them as query parameters
      if (yearParam && monthParam) {
        url += `?year=${yearParam}&month=${monthParam}`;
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (Array.isArray(response.data) && response.data.length > 0) {
        setApidata(response.data);
        setFilteredData(response.data);
      } else {
        console.warn("No consolidated data found.");
        setApidata([]);
        setFilteredData([]);
      }
    } catch (error) {
      console.error("Error fetching consolidated data:", error);
    }
  };

  // const fetchConsolidatedData = async (yearParam, monthParam) => {
  //   try {
  //     const token = localStorage.getItem("token");
  //     if (!token) {
  //       console.error("No token found");
  //       return;
  //     }

  //     let yearVal = yearParam;
  //     let monthVal = monthParam;

  //     if (!yearVal || !monthVal) {
  //       const today = new Date();
  //       const prevMonth = new Date(
  //         today.getFullYear(),
  //         today.getMonth() - 1,
  //         1
  //       );
  //       yearVal = prevMonth.getFullYear();
  //       monthVal = prevMonth.getMonth() + 1;
  //     }

  //     const response = await axios.get(
  //       `${process.env.REACT_APP_BASE_URL}/api/v4/consolidated-expenses?year=${yearVal}&month=${monthVal}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     // ✅ response.data is expected to be a plain array
  //     if (Array.isArray(response.data) && response.data.length > 0) {
  //       setApidata(response.data);
  //       setFilteredData(response.data);
  //     } else {
  //       console.warn("No consolidated data found for selected period.");
  //       setApidata([]);
  //       setFilteredData([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching consolidated data:", error);
  //   }
  // };

  const applyFilter = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return console.error("No token found");

      if (!year || !month) {
        Swal.fire({
          icon: "warning",
          title: "Missing Inputs",
          text: "Please select both year and month before applying filters.",
        });
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v4/consolidated-expenses?year=${year}&month=${month}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // ✅ Fix: use response.data directly
      const result = response.data;

      if (Array.isArray(result) && result.length > 0) {
        setApidata(result);
        setFilteredData(result);
        setShowFilterModal(false);
        return;
      }

      const generateConfirm = await Swal.fire({
        icon: "info",
        title: "No Data Found",
        text: `Data data not found for ${month}/${year}. Do you want to generate it now?`,
        showCancelButton: true,
        confirmButtonText: "Generate Data",
        cancelButtonText: "Cancel",
      });

      if (generateConfirm.isConfirmed) {
        Swal.fire({
          title: "Generating Data...",
          html: "Please wait while we process the consolidated data.",
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        // const generateRes = await axios.post(
        //   `${process.env.REACT_APP_BASE_URL}/api/v4/consolidated-expenses`,
        //   { year, month },
        //   {
        //     headers: {
        //       Authorization: `Bearer ${token}`,
        //     },
        //   }
        // );
        const generateRes = await axios.post(
          `${
            process.env.REACT_APP_BASE_URL
          }/api/v4/consolidated-expenses?year=${Number(year)}&month=${Number(
            month
          )}`,
          {}, // ← empty body
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        Swal.close();

        if (generateRes.data.success) {
          await Swal.fire({
            icon: "success",
            title: "Data Generated",
            text: "Data has been generated successfully!",
            confirmButtonText: "OK",
          });

          await fetchConsolidatedData(year, month);
          setShowFilterModal(false);
        } else {
          Swal.fire({
            icon: "error",
            title: "Generation Failed",
            text: generateRes.data.message || "Something went wrong.",
          });
        }
      }
    } catch (error) {
      Swal.close();
      console.error("Error during applyFilter:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while applying filters.",
      });
    }
  };

  const removeFilter = () => {
    setMonth("");
    setYear("");
    fetchConsolidatedData();
    setShowFilterModal(false);
  };

  useEffect(() => {
    fetchConsolidatedData();
  }, []);

  const handleSearch = () => {
    if (!dataFilter) return apidata;
    return apidata.filter((item) =>
      item.id_user?.name?.toLowerCase().startsWith(dataFilter.toLowerCase())
    );
  };

  const displayedData = handleSearch();

  return (
    <div className="table-responsive">
      <div className="row justify-content-between mb-2">
        {/* <div className="col-md-3 mb-2">
          <input
            type="text"
            placeholder="Search by name"
            className="form-control"
            value={dataFilter}
            onChange={(e) => setDataFilter(e.target.value)}
          />
        </div> */}
        <div className="col-md-9 mb-2">
          <button
            className="btn btn-primary"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
        </div>
      </div>

      {displayedData.length > 0 ? (
        <DataTable
          columns={columns}
          data={displayedData}
          pagination
          fixedHeader
          highlightOnHover
          responsive
          paginationPerPage={5}
          paginationRowsPerPageOptions={[5, 10, 15, 20]}
          onRowClicked={(row) => viewConsolidatedhistory?.(row)}
        />
      ) : (
        <p>No results found.</p>
      )}

      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        applyFilter={applyFilter}
        removeFilter={removeFilter}
        month={month}
        setMonth={setMonth}
        year={year}
        setYear={setYear}
      />
    </div>
  );
}
